import PropTypes from 'prop-types';
import Immutable from 'immutable';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FolderMapProp from '../types/props/FolderMapProp';
import TeamsProp from '../types/props/TeamsProp';
import { jsx as _jsx } from "react/jsx-runtime";
const RestrictedAccessIconPropTypes = {
  folder: FolderMapProp,
  teams: TeamsProp,
  isTeamsRequestSucceeded: PropTypes.bool.isRequired,
  fetchTeams: PropTypes.func.isRequired
};
const FolderTeamsListPropTypes = {
  teams: TeamsProp,
  teamIds: PropTypes.array.isRequired,
  isTeamsRequestSucceeded: PropTypes.bool.isRequired
};
const FolderTeamsList = ({
  teams,
  teamIds,
  isTeamsRequestSucceeded
}) => {
  if (!isTeamsRequestSucceeded || teams.isEmpty()) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      "data-test-id": "folder-teams-loading"
    });
  }
  return /*#__PURE__*/_jsx(UIList, {
    styled: true,
    "data-test-id": "tooltip-teams-list",
    children: teamIds.map(teamId => /*#__PURE__*/_jsx("span", {
      "data-test-object-id": teamId,
      children: teams.getIn([teamId, 'name']) || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.teams.unknown"
      })
    }, teamId))
  });
};
const RestrictedAccessIcon = ({
  folder,
  teams,
  isTeamsRequestSucceeded,
  fetchTeams
}) => /*#__PURE__*/_jsx(UITooltip, {
  headingText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "FileManagerCore.folderAccess.title"
  }),
  use: "longform",
  placement: "bottom",
  "data-test-id": "folder-access-tooltip",
  title: /*#__PURE__*/_jsx(FolderTeamsList, {
    teamIds: Immutable.List(folder.get('teams')).toArray(),
    teams: teams,
    isTeamsRequestSucceeded: isTeamsRequestSucceeded
  }),
  onOpenChange: () => {
    if (!isTeamsRequestSucceeded) {
      fetchTeams();
    }
  },
  children: /*#__PURE__*/_jsx(UIIcon, {
    name: "lists",
    "data-test-id": "restricted-access-icon"
  })
});
RestrictedAccessIcon.propTypes = RestrictedAccessIconPropTypes;
FolderTeamsList.propTypes = FolderTeamsListPropTypes;
export default RestrictedAccessIcon;